import React from 'react';
import Text from '../../../../components/Text';

export default function Comment({action}) {
  return action.data.content ? (
    <Text component="p" text={action.data.content}/>
  ) : null;
}
